import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, date }) =>
    present(
      repository
        .validateTimeRecords(project, date)
        .then(() => ({ project, date }))
        .catch(() => Promise.reject({ project, date })),
    );
}

export type { Interactor };

export { createInteractor };
